import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { updateLocale as fetchUpdateLocale } from '@/api/common';
import { useCommonStore } from '@/store';

export const useSetupUserLanguage = (currentLang: string) => {
  const { userLanguage, pendingUser } = useCommonStore(
    useShallow((s) => ({
      userLanguage: s.user?.language ? s.user.language : s.guestLanguage,
      pendingUser: s.pendingUser,
    }))
  );

  useEffect(() => {
    if (!pendingUser && userLanguage !== currentLang) {
      fetchUpdateLocale({ locale: currentLang });
    }
  }, [userLanguage, currentLang, pendingUser]);
};
